(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["voerfinder"]) return;
  try {
    

$('.closebtn').click(function(e){
	$('#voerfinder').removeClass('active');	
	e.preventDefault();
});
  

document.addEventListener('DOMContentLoaded', function() {
  
$('.show-voerfinder').click(function(e){
	$('#voerfinder').toggleClass('active');	
	e.preventDefault();
});
  

    new Vue({
        el: '#voerfinder',
        data: {
            info: [],
            saved: false,
            tags : [],
			Diertype : '',
			step : 1,
            fiterTags: [],
          health: false

        },

       computed: {
            fiterTagsString() {
            var url;
              if (this.Diertype == 'kat'){
                url = 'https://pawty.nl/collections/kat-voer/';
              }else{
                url = 'https://pawty.nl/collections/hond-voer/';
              }
            return url + this.fiterTags.join('+')
          }
        },
               
        methods: {


			checkTags(type,name){
				if (this.tags[type]){
					return this.tags[type].includes(name);
				}else{
					return false;
				}
			},

			show(){		


			},
			close(){
				var element = document.getElementById("voerfinder").classList.remove("active");
			},
			setTag(type,name){
				this.tags[type] = name;
                this.fiterTags.push(name);
				this.Diertype =this.tags['species'];
				this.step++;
				if (this.step == 4 && this.Diertype == 'kat'){
					this.step = 5;
				}
			},
			setTags(type,name){
				this.tags[type] = name;
                this.fiterTags.push(name);
				this.Diertype =this.tags['species'];

              window.location = this.fiterTagsString;

			},
			back(type,name){
				this.step--;
			}
        }
    })
});
  

  } catch(e) { console.error(e); }
})();
})();
